<template>
  <div class="l-diamond">
    <div class="diamond" v-for="(diamond, index) in diamonds" :key="diamond + index">
      <img :src="require('../../images/' + diamond.type + '.png')" alt />
      {{ diamond.num }}
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Class2 from '@/models/classcore'
const { mapState } = createNamespacedHelpers('user')
const class2 = new Class2()

export default {
  name: 'l-diamond',
  data() {
    return {
      diamonds: [], //钻石
    }
  },
  computed: {
    ...mapState(['user']),
  },
  methods: {
    getDiamond() {

      class2.getJewel().then(res => {
        this.diamonds = res.data || []
      })
    },
  },
  mounted() {
    this.getDiamond()
  },
}
</script>

<style lang="stylus" scoped>
@import './index.styl'
</style>
